import { createFileRoute } from '@tanstack/react-router'
import React from 'react'
import { useTitle } from '../hooks/use-title'
import { useTranslation } from 'react-i18next'
import { Flex } from 'antd'
import { PageTitle } from '../components/page-title'

export const Route = createFileRoute('/_auth/_main/company')({
    component: CompanyProfile,
})

function CompanyProfile() {
    const { t } = useTranslation()

    useTitle(t('Settings'))

    return (
        <Flex
            gap="large"
            vertical
        >
            <PageTitle
                title={t('Company profile')}
                className="mb-0"
            />
        </Flex>
    )
}
